import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.map";
import React from 'react';
import PropTypes from 'prop-types';
import Block from '../../../block/Block';
import CmsContent from '../../CmsContent';
import Accordion from '../../../accordion/Accordion';
import FaqQuestion from '../../../faq/FaqQuestion';
import FaqAnswer from '../../../faq/FaqAnswer';
import styles from './Faq.less';
export var Faq = function Faq(_ref) {
  var data = _ref.data;

  var _ref2 = data || {},
      _ref2$component = _ref2.component;

  _ref2$component = _ref2$component === void 0 ? {} : _ref2$component;
  var _ref2$component$conte = _ref2$component.content;
  _ref2$component$conte = _ref2$component$conte === void 0 ? {} : _ref2$component$conte;
  var faqContent = _ref2$component$conte.faq_content;
  return faqContent && Array.isArray(faqContent) && faqContent.length ? /*#__PURE__*/React.createElement(Block, {
    className: styles['cms-faq-wrapper'],
    "data-en": 'cms-faq'
  }, faqContent.map(function (item, index) {
    var _ref3 = item || {},
        question = _ref3.question,
        answer = _ref3.answer;

    return /*#__PURE__*/React.createElement(Accordion, {
      key: index
    }, /*#__PURE__*/React.createElement(Accordion.Control, {
      headingLevel: "2"
    }, /*#__PURE__*/React.createElement(FaqQuestion, null, " ", /*#__PURE__*/React.createElement(CmsContent, {
      content: question
    }))), /*#__PURE__*/React.createElement(Accordion.Content, null, /*#__PURE__*/React.createElement(FaqAnswer, null, /*#__PURE__*/React.createElement(CmsContent, {
      content: answer
    }))));
  })) : null;
};
Faq.propTypes = {
  data: PropTypes.object.isRequired
};
export default Faq;